import { isBackCamera } from '@/helpers/mobile-utils';

export default {
  isBackCameraSelected: (state, getters, rootState, rootGetters) => {
    const currentCameraLabel = rootGetters.currentCameraLabel;
    return !!(currentCameraLabel && isBackCamera(currentCameraLabel));
  }
};
